import { render, staticRenderFns } from "./repairReturnVisitList.vue?vue&type=template&id=c1885f74&scoped=true"
import script from "./repairReturnVisitList.vue?vue&type=script&lang=js"
export * from "./repairReturnVisitList.vue?vue&type=script&lang=js"
import style0 from "./repairReturnVisitList.vue?vue&type=style&index=0&id=c1885f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1885f74",
  null
  
)

export default component.exports